// import React from "react";
// import {
//   Button,
//   DropdownMenu,
//   NewTable,
//   SmartTooltip,
// } from "../../../../../../components";
// import { mapTableRows } from "../../../../../../utils";

// const HoldEmployees = () => {
//   const handleEdit = (row) => {
//     console.log(row);
//   };
//   const handleDelete = (row) => {
//     console.log(row);
//   };
//   const handleView = (row) => {
//     console.log(row);
//   };
//   const handleDownload = (row) => {
//     console.log(row);
//   };
//   const tableData = [];
//   const columns = [
//     { key: "employeeName", label: "Employee Name" },
//     { key: "salary", label: "Salary" },
//     { key: "basePay", label: "Base Pay" },
//     { key: "timesheets", label: "Timesheets" },
//     { key: "expenses", label: "Expenses" },
//     { key: "otherPayment", label: "Other Payment" },
//     { key: "advancePayments", label: "Advance Payments" },
//     { key: "advancePayDeductions", label: "Advance Pay Deductions" },
//     { key: "deductions", label: "Deductions" },
//     { key: "lossOfPay", label: "Loss of Pay" },
//     { key: "miscellaneousPayments", label: "Miscellaneous Payments" },
//     { key: "PerDiem", label: "Per Diem" },
//     { key: "Commision", label: "Commision" },
//     { key: "Total", label: "Total" },

//     {
//       key: "action",
//       label: "Action",
//       sortable: false,
//       render: (row) => (
//         <div className="flex gap-2">
//           <Button
//             type="icon"
//             variant="text"
//             icon="published_with_changes"
//             size="xs"
//             color="black"
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="guardian"
//             size="xs"
//             color="black"
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="body_system"
//             size="xs"
//             color="black"
//           />
//           <Button
//             type="icon"
//             variant="text"
//             icon="history"
//             size="xs"
//             color="black"
//           />
//         </div>
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(tableData, columns);
//   return (
//     <NewTable
//       fixedCol={1}
//       showCheckbox
//       rows={mappedRows}
//       columns={columns}
//       toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//       customSection={
//         <div className="flex gap-2 ml-1">
//           <Button title={"Search"} size="sm" />
//           {/* <Button
//             title={"Add Exit  Employee"}
//             size="sm"
//             icon="add" />
//           <Button
//             title={"Update Employees Paydata"}
//             size="sm" /> */}
//           <DropdownMenu
//             MenuSection={
//               <div className="flex flex-col">
//                 <Button
//                   title={"EXCEL"}
//                   variant="text"
//                   color="black"
//                   size="xs-sm"
//                   className="!justify-start py-1"
//                 />
//                 <Button
//                   title={"CSV"}
//                   variant="text"
//                   color="black"
//                   size="xs-sm"
//                   className="!justify-start py-1"
//                 />
//               </div>
//             }
//           >
//             <Button
//               color="black"
//               title=""
//               size="md"
//               icon={"screen_share"}
//               variant="text"
//             />
//           </DropdownMenu>
//         </div>
//       }
//     />
//   );
// };

// export default HoldEmployees;

import React, { useEffect, useState } from "react";
import {
  Button,
  Drawer,
  DropdownMenu,
  TableAdv,
  SmartTooltip,
  ToolTip,
} from "../../../../../../components";
import {
  formatNumber,
  getEmployeeId,
  mapTableRows,
} from "../../../../../../utils";
import FinalizeModal from "../Modals/FinalizeModal";
import ProposedEmployeesDetails from "./ProposedEmployeesDetails/ProposedEmployeesDetails";
import { totalCountStart } from "../../../../../../redux/slices/totalCount/totalCountSlice";
import {
  clearCurrentPayrollEditing,
  clearEmpPayConfigMain,
  clearPayroll,
  getAllEmpPayConfigsStart,
  getAllPayrollStart,
  updatePayrollStart,
} from "../../../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../../../../../../utils/stringUtils";

const HoldEmployees = ({ configData }) => {
  const dispatch = useDispatch();
  const { payroll: ProposedEmployees, loading } =
    useSelector((state) => state.payRoll) || {};
  const { value } = useSelector((state) => state.totalCount);
  const [searchQuery, setSearchQuery] = useState("");

  const isAggregate = !!ProposedEmployees?.data?.[0]?.data;
  const dataArray = isAggregate ? ProposedEmployees.data[0].data : (ProposedEmployees?.data || []);
  const totalCount = isAggregate ? (ProposedEmployees?.data?.[0]?.count?.[0]?.total || 0) : value?.payrolls?.data;
  
  const [forceRender, setForceRender] = useState(false);

  const forceRerender = () => {
    setForceRender((prev) => !prev);
  };

  const handleSearch = (key, val) => {
    setSearchQuery(val);
    setPage(1);
  };

  const fetchPayrolls = () => {
    let payload = { coll: "Payroll", limit: limit, page: page };
    if (searchQuery) {
      payload.useAggregate = true;
      payload.filters = {
        payDayEmployeesSearch: {
          type: "AG_LOOKUP_DATA",
          value: [
            searchQuery,
            configData?.salaryProfileId?.uiid,
            configData?.payCycle?.from,
            configData?.payCycle?.to,
            3
          ]
        }
      };
    } else {
      payload.ref = "Employee SalProfile PayConfig InsuranceDed RegularDed ShortPay ExcessPay";
      payload.filters = {
        status: { type: "NONE", value: 3 },
        "payCycle.from": { type: "GTE", value: configData?.payCycle?.from },
        "payCycle.to": { type: "LTE", value: configData?.payCycle?.to },
        salaryProfileId: { type: "NONE", value: configData?.salaryProfileId?.uiid },
      };
    }
    dispatch(getAllPayrollStart(payload));
    if (!searchQuery) {
      dispatch(totalCountStart({ collection: "payrolls", coll: "Payroll", filters: payload.filters }));
    }
  };

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  useEffect(() => {
    fetchPayrolls();
    return () => {
      dispatch(clearPayroll());
    };
  }, [dispatch, limit, page, forceRender, searchQuery, configData]);
  const [FinalizeModalOpen, setFinalizeModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleEdit = (row) => {
    console.log(row);
  };
  const handleDelete = (row) => {
    console.log(row);
  };
  const handleView = (row) => {
    console.log(row);
  };
  const handleDownload = (row) => {
    console.log(row);
  };

  const tableData = [
    {
      employeeName: "Abdul Waseem Syed",
      employeeID: "EMP-12345",
      employeeCategory: "W2",
      salaryType: " Hourly",
      lcaMonthly: "7673.50",
      timesheets: "8332.80",
      expenses: "0.00",
      deductions: "692.86",
      healthInsurance: "0.00",
      adjustmentPayments: "100.00",
      perDiem: "0.00",
      commision: "0.00",
      total: "7639.94",
      info: "Please check the payment details and save the Paystub to process further",
    },
    // {
    //   employeeName: "Abubakar Mohammed",
    //   employeeID: "EMP-12345",
    //   employeeCategory: "W2",
    //   salaryType: " Hourly",
    //   lcaMonthly: "1693.96",
    //   timesheets: " 0.00",
    //   expenses: " 0.00",
    //   deductions: "692.86",
    //   healthInsurance: "1362.70",
    //   adjustmentPayments: "-200.00",
    //   perDiem: "0.00",
    //   commision: " 0.00",
    //   total: "7639.94",
    // },
    // {
    //   employeeName: "Aishwarya Vedula",
    //   employeeID: "EMP-12345",
    //   employeeCategory: "",
    //   salaryType: " Hourly",
    //   lcaMonthly: "7673.50",
    //   timesheets: "8320.00",
    //   expenses: "0.00",
    //   deductions: "183.50",
    //   healthInsurance: " 0.00",
    //   adjustmentPayments: "100.00",
    //   perDiem: "0.00",
    //   commision: " 0.00",
    //   total: "7639.94",
    //   info: "Please check the payment details and save the Paystub to process further",
    // },
  ];
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        const employeeName =
          row?.employeeId?.firstName && row?.employeeId?.lastName
            ? `${row?.employeeId?.firstName
                .charAt(0)
                .toUpperCase()}${row?.employeeId?.firstName.slice(
                1,
              )} ${row?.employeeId?.lastName
                .charAt(0)
                .toUpperCase()}${row?.employeeId?.lastName.slice(1)}`
            : "-";
        return (
          <SmartTooltip
            description={employeeName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <span
              className=""
              onClick={() => {
                // setRowData(row);
                // setOpenDrawer(!openDrawer);
              }}
            >
              {employeeName}
            </span>
          </SmartTooltip>
        );
      },
    },
    {
      key: "employeeID",
      label: "Employee ID",
      render: (row) => (
        <span>
          {getEmployeeId(
            row?.employeeId?.uiid,
            row?.employeeId?.employmentType,
          ) || "-"}
        </span>
      ),
    },
    {
      key: "employeeCategory",
      label: "Employee Category",
      render: (row) => <span>{row?.salaryProfileId?.name || "-"}</span>,
    },
    {
      key: "salaryType",
      label: "Salary Type",
      render: (row) => (
        <span>
          {row?.payConfigId?.lca?.type === 1
            ? "Monthly"
            : row?.payConfigId?.lca?.type === 2
              ? "Yearly"
              : "-" || "-"}
        </span>
      ),
    },
    {
      key: "lcaMonthly",
      label: "LCA Monthly",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.payConfigId?.lca?.type === 2
              ? row?.payConfigId?.lca?.wages / 12
              : row?.payConfigId?.lca?.wages,
          ) || "-"}
        </span>
      ),
    },
    {
      key: "timesheets",
      label: "Timesheets",
      render: (row) => (
        <span> {formatCurrency(row?.timesheets?.totalPay) || "-"}</span>
      ),
    },
    {
      key: "expenses",
      label: "Expenses",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) =>
                item?.type?.toLowerCase().includes("commission"),
              )
              .reduce((sum, item) => sum + (item?.amount || 0), 0),
          ) || "-"}
        </span>
      ),
    },
    {
      key: "deductions",
      label: "Deductions",
      render: (row) => <span>{formatCurrency(row?.amounts?.diff) || "-"}</span>,
    },
    {
      key: "healthInsurance",
      label: "Health Insurance",
      render: (row) => (
        // <span>
        //   {formatCurrency(
        //     row?.deductions?.insurance?.ids?.installments?.find(
        //       (item) => item?.payrollId === row?.uiid
        //     )?.received
        //   ) || "-"}
        // </span>
        <span>{formatCurrency(row?.amounts.insurance) || "-"}</span>
      ),
    },
    {
      key: "adjustmentPayments",
      label: "Adjustment Payments",
      render: (row) => {
        return <span className="">{"-"}</span>;
      },
    },

    {
      key: "perDiem",
      label: "Per Diem",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) => item?.type?.toLowerCase().includes("per diem"))
              .reduce((sum, item) => sum + (item?.amount || 0), 0),
          ) || "-"}
        </span>
      ),
    },
    {
      key: "commision",
      label: "Other Payments",
      render: (row) => (
        <span>{formatCurrency(row?.otherPays?.totalAmt) || "-"}</span>
      ),
    },
    {
      key: "total",
      label: "Total",
      render: (row) => (
        <span> {formatCurrency(row?.amounts?.netPay) || "-"}</span>
      ),
    },

    {
      key: "action",
      label: "Action",
      sortable: false,
      render: (row) => (
        <div className="flex gap-2 z-50">
          <Button
            type="icon"
            variant="text"
            icon="visibility"
            size="sm"
            onClick={() => {
              setRowData(row);
              setOpenDrawer(!openDrawer);
            }}
          />
          {/* <ToolTip   description={"Finalize Employee"} tooltipPosition="left" size="xs-sm" noicon> */}
          <Button
            type="icon"
            variant="text"
            icon="undo"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 1)}
          />
          {/* </ToolTip> */}
        </div>
      ),
    },
  ];
  const tableData2 = dataArray.map((item) => ({
      id: item.uiid,
      ...item,
    })) || [];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);

  const handleRevertSingle = async (id, status) => {
    if (!id) {
      showToast("No Payroll Selected To Revert", "info", 3000);
      return;
    }

    dispatch(
      updatePayrollStart({
        uiid: id,
        coll: "Payroll",
        payload: [
          {
            type: "SET",
            value: {
              status: status,
            },
          },
        ],
        customToast:
          status === 1
            ? "Payroll Moved To Proposed"
            : status === 3
              ? "Payroll Moved To Hold"
              : undefined,
        onSuccess: () => {
          fetchPayrolls();
        },
      }),
    );
  };

  return (
    <>
      <TableAdv
        tableId={`payroll_upcomingpaydays_holdemployees`}
        onSelectionChange={setSelectedRows}
        defaultSelectedRows={selectedRows}
        showCheckbox
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        serverOnSearch={handleSearch}
        page={page}
        limit={limit}
        totalCount={totalCount}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: true,
          filter: false,
          download: false,
          add: [
            {
              component: <Button title="Search" size="sm" />,
            },
            {
              component: (
                <DropdownMenu
                  MenuSection={
                    <div className="flex flex-col">
                      <Button
                        title={"EXCEL"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                      />
                      <Button
                        title={"CSV"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                      />
                    </div>
                  }
                >
                  <Button
                    color="black"
                    title=""
                    size="md"
                    icon={"screen_share"}
                    variant="text"
                  />
                </DropdownMenu>
              ),
            },
          ],
        }}
      />
      <div>
        <Drawer
          isOpen={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
            setRowData({});
            dispatch(clearCurrentPayrollEditing());
            fetchPayrolls();
          }}
          position="left" // 'left', 'right', 'top', 'bottom'
          width="w-[80%]" // custom width using Tailwind classes
          title=""
          closeOnOutsideClick
          showCloseButton={false}
          className="!p-0"
          bodyGap={false}
        >
          <div>
            <ProposedEmployeesDetails
              disableEditing={true}
              hideButtons={true}
              onHoldClick={() => {
                setOpenDrawer(false);
                setRowData({});
                dispatch(
                  getAllPayrollStart({
                    coll: "Payroll",
                    // useAggregate: true,
                    limit: limit,
                    page: page,
                    // ref: "Employee SalaryProfile",
                    // ref: "Employee SalProfile PayConfig Deduction",
                    ref: "Employee SalProfile PayConfig InsuranceDed RegularDed ShortPay ExcessPay",
                    filters: {
                      status: {
                        type: "NONE",
                        value: 2,
                      },
                      "payCycle.from": {
                        type: "GTE",
                        value: configData?.payCycle?.from,
                      },
                      "payCycle.to": {
                        type: "LTE",
                        value: configData?.payCycle?.to,
                      },
                      salaryProfileId: {
                        type: "NONE",
                        value: configData?.salaryProfileId?.uiid,
                      },
                    },
                  }),
                );
                dispatch(
                  totalCountStart({
                    collection: "payrolls",
                    coll: "Payroll",
                    filters: {
                      // status: {
                      //   type: "NONE",
                      //   value: 1,
                      // },
                      "payCycle.from": {
                        type: "GTE",
                        value: configData?.payCycle?.from,
                      },
                      "payCycle.to": {
                        type: "LTE",
                        value: configData?.payCycle?.to,
                      },
                      salaryProfileId: {
                        type: "NONE",
                        value: configData?.salaryProfileId?.uiid,
                      },
                    },
                    // ref:"SalaryProfile"
                  }),
                );
              }}
              rowData={rowData}
            />
          </div>
        </Drawer>
      </div>
      <FinalizeModal
        isOpen={FinalizeModalOpen}
        onClose={() => setFinalizeModalOpen(false)}
      />
    </>
  );
};

export default HoldEmployees;
